var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3V6H3V3H6ZM7.5 1.5H1.5V7.5H7.5V1.5ZM13.5 3V6H10.5V3H13.5ZM15 1.5H9V7.5H15V1.5ZM21 3V6H18V3H21ZM22.5 1.5H16.5V7.5H22.5V1.5ZM6 10.5V13.5H3V10.5H6ZM7.5 9H1.5V15H7.5V9ZM13.5 10.5V13.5H10.5V10.5H13.5ZM15 9H9V15H15V9ZM21 10.5V13.5H18V10.5H21ZM22.5 9H16.5V15H22.5V9ZM6 18V21H3V18H6ZM7.5 16.5H1.5V22.5H7.5V16.5ZM13.5 18V21H10.5V18H13.5ZM15 16.5H9V22.5H15V16.5ZM21 18V21H18V18H21ZM22.5 16.5H16.5V22.5H22.5V16.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGrid);
export default __webpack_public_path__ + "static/media/ic-grid.930e3d0ee2de9632df18b5832ab3a635.svg";
export { ForwardRef as ReactComponent };